import React from 'react';
import { Field } from '@plone/volto/components';
import { useIntl } from 'react-intl';
import messages from '../../../../messages';

const EditSchema = ({ data = {}, block, onChangeBlock }) => {
  const handle = (id, value) => onChangeBlock(block, { ...data, [id]: value });

  const intl = useIntl();

  return (
    <div className="ui form">
      <fieldset>
        <legend>{intl.formatMessage(messages.quoteContent)}</legend>
        <Field
          id="quote"
          title={intl.formatMessage(messages.quoteQuote)}
          description={intl.formatMessage(messages.quoteDesc)}
          widget="textarea"
          value={data.quote || ''}
          onChange={handle}
          required
        />
        <Field
          id="author"
          title={intl.formatMessage(messages.quoteAuthor)}
          value={data.author || ''}
          onChange={handle}
        />
      </fieldset>

      <fieldset>
        <legend>{intl.formatMessage(messages.quoteStil)}</legend>
        <Field
          id="background_color"
          title="Hintergrund"
          description="Wähle die Hintergrundfarbe."
          widget="fcmhColorSelect"
          value={data.background_color || 'gray'}
          onChange={handle}
          choices={[
            ['gray', 'Grau'],
            ['white', 'Weiß'],
            ['blue', 'Blau'],
            ['yellow', 'Gelb'],
          ]}
        />
      </fieldset>
    </div>
  );
};

export default EditSchema;
